<template>
    <div class="top-menu">
        <v-menu bottom left>
            <template v-slot:activator="{ on }">
                <v-btn
                    dark
                    icon
                    v-on="on"
                >
                    <v-icon size="48" color="grey" class="pa-2">more_vert</v-icon>
                </v-btn>
            </template>

            <v-list>
                <v-list-item
                    dense
                    v-for="(item, i) in itemsFiltered"
                    :key="i"
                    @click="navigate(item.route)"
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
    export default {
        name: "GapptMenu",
        props: [
          "user",
        ],
        data() {
            return {
                items: [
                    {
                        title: 'Launchpad',
                        icon: 'dashboard',
                        route: 'home',
                    },
                    {
                        title: 'Profile',
                        icon: 'account_circle',
                        route: 'profile',
                    },
                    {
                        title: 'Quick Pin Switch',
                        icon: 'published_with_changes',
                        route: 'pin-switch',
                    },
                    {
                        title: 'Manage Application Access',
                        icon: 'fact_check',
                        route: 'resourcesAccess',
                        adminOnly: true,
                    },
                    {
                        title: 'Manually add account',
                        icon: 'pregnant_woman',
                        route: 'createAccount',
                        adminOnly: true,
                    },
                    {
                        title: 'Logout',
                        icon: 'logout',
                        route: 'logout',
                    },
                ]
            }
        },
        computed: {
            itemsFiltered () {
                return this.items.filter(item => {
                    return !item.adminOnly || this.user.admin
                })
            }
        },
        methods: {
            navigate(route) {
                if (route) {
                    this.$router.replace({
                        name: route
                    });
                }
            }
        }
    }
</script>

<style>
    .top-menu {
        position: absolute;
        right: 0;
        top: 0;
    }
</style>
